import jwt_decode from "jwt-decode";
import { User } from "../types/orders/user";
import { TRACY_AUTH_BASE_URL } from "../redux/actions/dashboard/env.variables";

class TracyAuthService {
    readonly loginUrl = TRACY_AUTH_BASE_URL + "/api/commerce/salesrep/auth/external_sso";

    async login(token: string): Promise<string | null> {
        try {
            const response = await fetch(this.loginUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    originSystem: "axum_accounts",
                    token
                })
            });

            if (!response.ok) {
                console.error("TracyAuthService.login failed:", response.statusText);
                return null;
            }

            const { token: tracyToken, expireIn } = await response.json();

            // Guardar el JWT y expiración en sessionStorage
            sessionStorage.setItem("tracyJWT", tracyToken);
            sessionStorage.setItem("tracyJWTExpire", expireIn);

            // Decodificar y devolver info del usuario
            //const user = jwt_decode<User>(tracyToken);
            return tracyToken;
        } catch (ex) {
            console.error("Error in TracyAuthService.login:", ex);
            return null;
        }
    }
}

export default new TracyAuthService();
